import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { usePostInquiryTractorMutation } from '../../../../hooks/api/inquiry/mutations/usePostInquiryTractor.mutation';
import { usePopup } from '../../../../hooks/popup/usePopup';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IOpenMarketProductDetail } from '../../../../interfaces/Product.interfaces';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';
import { getOpenMarketProductTitle } from '../../../../utils/getter/getOpenMarketProductTitle.util';
import { requestLogin } from '../../../../utils/modal/requestLogin.util';

interface OpenMarketRequestConsultButtonProps {
  product: IOpenMarketProductDetail;
}

export const OpenMarketRequestConsultButton = ({ product }: OpenMarketRequestConsultButtonProps) => {
  const Popup = usePopup();
  const navigate = useNavigate();
  const location = useLocation();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const { mutate: postUserInquiryTractor } = usePostInquiryTractorMutation();

  return (
    <Button
      onClick={() => {
        postUserInquiryTractor({ reqBody: { productId: product.id } });

        if (product) {
          ampli.마켓오픈마켓매물전화상담버튼클릭({
            '게시글 제목': getOpenMarketProductTitle(product) ?? '',
            '매물 코드': product?.code,
          });
        }

        if (isUserLoggedIn) {
          if (window.ReactNativeWebView) {
            postMessageToRN({ messageKey: 'link', messageParam: `tel:${product.user?.phoneNumber}` });
          } else {
            window.location.href = `tel:${product.user?.phoneNumber}`;
          }
        } else {
          requestLogin(Popup, navigate);
        }
      }}
    >
      {'판매자에게 전화 문의하기'}
    </Button>
  );
};

const Button = styled.button`
  width: 100%;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px;

  gap: 4px;

  border-radius: 8px;
  background: #445eff;

  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
